module.exports = __webpack_public_path__ + "img/Step2-m.fee20a7.svg";